/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - CSS-трансформации</h2>
    <p className={styles.description}>
      CSS-трансформации позволяют изменять размер, форму и положение элемента на веб-странице с помощью свойства{' '}
      <code className={styles.code}>transform</code>.
    </p>
    <p className={styles.description}>
      Трансформации преобразовывают элемент так, что другие элементы не сдвигаются относительно него. По умолчанию
      трансформация происходит относительно центра элемента.
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.1 - Translate</h3>
      <p className={styles.description}>Перемещает элемент в горизонтальном и/или вертикальном направлениях. </p>
      <p className={styles.description}>
        <code className={styles.code}>translate (translateX, translateY), translate3d, translateZ</code>{' '}
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="flex-row-column"
        src="https://codepen.io/GoIT-fe/embed/yoxaXb?default-tab=html%2Cresult"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.2 - Rotate</h3>
      <p className={styles.description}>
        Вращение вдоль оси X, Y или Z. Вращение вдоль оси X, Y выглядит как сжатие изображения, а вдоль Z - как
        вращения.{' '}
      </p>
      <p className={styles.description}>
        <code className={styles.code}>rotate(rotateX, rotateY), rotate3d, rotateZ</code>{' '}
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="flex-row-column"
        src="https://codepen.io/GoIT-fe/embed/ZJMpBy?default-tab=html%2Cresult"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.3 - Scale</h3>
      <p className={styles.description}>
        Изменение масштаба элемента. Может перекрывать отображение соседних элементов.{' '}
      </p>
      <p className={styles.description}>
        <code className={styles.code}>scale(scaleX, scaleY), scale3d, scaleZ</code>{' '}
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="flex-row-column"
        src="https://codepen.io/GoIT-fe/embed/ayamJG?default-tab=html%2Cresult"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
  </section>
))
